export const interceptorResponseHandler = response => response

export const interceptorErrorHandler = error => Promise.reject(error)
